import React, { Component, useState, useMemo } from "react";
import DefaultDataGrid from './DefaultDataGrid';
import { useParams } from 'react-router';
import { TextField, Typography, Slide, Button, Box, CircularProgress, Grid } from '@mui/material';
import { Stack } from '@mui/system';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import { query, flattenObj, unflattenObject } from '../App';
import InputColumn from './InputColumn'
import InputRow from './InputRow'
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Link, useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';

export default function DefaultSite(props) {
    const [saving, setSaving] = React.useState(false);
    const navigate = useNavigate();

    const handleAdd = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        let obj = {};
        for (const key of data.keys()) {
            obj[key] = data.get(key);
        }
        setSaving(true);
        query(props.queryPath, 'POST', unflattenObject(obj)).then(res => {
            setSaving(false);
            navigate(props.queryPath);
        })
    }

    return (<Box className="container"><Grid component="form" onSubmit={handleAdd} container columnSpacing={{ xs: 1, sm: 2, md: 3 }} >
        <Grid xs={12} item>
            <Button variant="contained" startIcon={<KeyboardReturnIcon />} component={Link} to={props.queryPath}>Cofnij</Button>
        </Grid>
        <Grid xs={12} item>
            <Typography variant="h6" textAlign="left">
                {props.title}
            </Typography>
        </Grid>
        {props.children}
        <Grid xs={12} item
            justifyContent="flex-end">
            <LoadingButton
                loading={saving}
                loadingPosition="start"
                type="submit"
                startIcon={<AddIcon />}
                variant="contained">Dodaj
            </LoadingButton>
        </Grid>
    </Grid ></Box>);
}